import React from 'react';

class CountdownTimer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  render() {
    return (
      <div id="film-container">
        <div className="animated-flicker">
          <svg id="film-mask" version="1.1" xmlns="http://www.w3.org/2000/svg"
            width="100%" height="100%" preserveAspectRatio="none" viewBox="0 0 400 225">
            <line id="line-h" className="line01" x1="0" y1="112.5" x2="400" y2="112.5"/>
            <line id="line-v" className="line02" x1="200" y1="0" x2="200" y2="225"/>
          </svg>
          <svg id="film-countdown" version="1.1" xmlns="http://www.w3.org/2000/svg"
            width="100%" height="100%" viewBox="0 0 400 225">
            <circle id="circle-outer" className="circle01" cx="200" cy="112.5" r="95"/>
            <circle id="circle-inner" className="circle01" cx="200" cy="112.5" r="85"/>
            <circle className="circle02 animated-rotate" cx="200" cy="112.5" r="494.5"/>
            <g id="numbers" textAnchor="middle" className="no-select">
              <text id="animated-text" x="200.5" y="155">{this.props.number}</text>
            </g>
          </svg>
        </div>
      </div>
    );
  }
}

export default CountdownTimer;


// WEBPACK FOOTER //
// src/CountdownTimer.js